import type { IAdminMembershipRepository } from "@/application/ports/repositories";
import type {
  MembershipCreateRequest,
  MembershipUpdateRequest,
  AdminMembership,
} from "@/domain/admin";
import { apiClient } from "../client";

export class AdminMembershipRepository implements IAdminMembershipRepository {
  private basePath = "/admin/memberships";

  async createMembership(data: MembershipCreateRequest): Promise<AdminMembership> {
    const response = await apiClient.post<AdminMembership>(this.basePath, data);
    return response.data;
  }
  async updateMembership(uuid: string, data: MembershipUpdateRequest): Promise<AdminMembership> {
    const response = await apiClient.patch<AdminMembership>(`${this.basePath}/${uuid}`, data);
    return response.data;
  }
  async deleteMembership(uuid: string): Promise<void> {
    await apiClient.delete(`${this.basePath}/${uuid}`);
  }
  async getUserMemberships(userUuid: string): Promise<AdminMembership[]> {
    const response = await apiClient.get<AdminMembership[]>(`/admin/users/${userUuid}/memberships`);
    return response.data;
  }
}
